// extracted by mini-css-extract-plugin
module.exports = {"body":"style-module--body--Rcn9B"};